<template>
  <div id="JSDecoderPlayerWind" class="JSDecoderPlayerWind" ref="JSDecoderPlayerWind"></div>
</template>
<script>
  export default {
    name: 'JSDecoderPlaye',
    props: {
      //插件支持的最大窗口分割数,
      iMaxSplit: {
        type: Number,
        default: 1
      },
      //插件创建后默认的窗口分割数
      iCurrentSplit: {
        type: Number,
        default: 1
      },
      //窗口样式
      oStyle: {
        type: Object,
        default: () => {
          return {
            border: '#343434', //边框颜色
            // borderSelect: "#F56C6C", //窗口被选中后边框颜色
            borderSelect: '#343434', //窗口被选中后边框颜色
            background: '#4C4B4B' //窗口背景色
          }
        }
      }
    },
    data() {
      return {
        WindH: 400,
        WindW: 600,
        oPlugin: null, //插件对象
        iWind: 0 //当前选中的窗口编号
      }
    },
    watch: {},
    computed: {},
    created() {},
    mounted() {
      this.init()
    },
    methods: {
      /* 初始化插件 */
      init(e) {
        //设置宽高
        this.getWindHW(e)
        let iWidth = 600
        let iHeight = 400
        if (this.WindH > 0 && this.WindW > 0) {
          iWidth = this.WindW
          iHeight = parseInt((iWidth * 2) / 3)
        }
        //创建对象
        var oPlugin = new JSPlugin({
          szId: 'JSDecoderPlayerWind',
          iWidth: iWidth,
          iHeight: iHeight,
          iMaxSplit: this.iMaxSplit,
          iCurrentSplit: this.iCurrentSplit,
          szBasePath: './static/JSDecoder',
          oStyle: {
            border: this.oStyle.border,
            borderSelect: this.oStyle.borderSelect,
            background: this.oStyle.background
          }
        })
        this.oPlugin = oPlugin
        this.initPlugin()
      },

      fullSreen() {
        this.oPlugin.JS_FullScreenDisplay(true).then(
          function () {
            console.log('JS_FullScreenDisplay success')
          },
          function () {
            console.log('JS_FullScreenDisplay failed')
          }
        )
      },
      //事件注册
      initPlugin() {
        if (this.oPlugin) {
          this.oPlugin.JS_SetWindowControlCallback({
            windowEventSelect: function (iWndIndex) {
              //插件选中窗口回调
              this.iWind = iWndIndex
              console.log(iWndIndex)
            },
            pluginErrorHandler: function (iWndIndex, iErrorCode, oError) {
              //插件错误回调
              console.log(iWndIndex, iErrorCode, oError)
            },
            windowEventOver: function (iWndIndex) {
              //鼠标移过回调
              //console.log(iWndIndex);
            },
            windowEventOut: function (iWndIndex) {
              //鼠标移出回调
              //console.log(iWndIndex);
            },
            windowEventUp: function (iWndIndex) {
              //鼠标mouseup事件回调
              //console.log(iWndIndex);
            },
            windowFullCcreenChange: function (bFull) {
              //全屏切换回调
              console.log(bFull)
            },
            firstFrameDisplay: function (iWndIndex, iWidth, iHeight) {
              //首帧显示回调
              console.log(iWndIndex, iWidth, iHeight)
            },
            performanceLack: function () {
              //性能不足回调
            }
          })
          this.oPlugin
            .JS_SetOptions({
              bSupportSound: false //是否支持音频，默认支持
              //bSupporDoubleClickFull: false  //是否双击窗口全屏，默认支持
              //bOnlySupportMSE: true  //只支持MSE
              //bOnlySupportJSDecoder: true  //只支持JSDecoder
            })
            .then(function () {
              console.log('JS_SetOptions')
            })
        }
        this.$nextTick(() => {
          // this.realplay();
          // this.fullSreen()
        })
      },

      chackPlayer(callback) {
        if (this.oPlugin) {
          callback(true)
        } else {
          callback(false)
        }
      },

      //开始播放
      realplay(url) {
        console.log(url)
        if (!url) {
          return
        }
        // url = 'ws://219.129.17.226:559/openUrl/TyeG6Va'
        let _this = this
        this.oPlugin
          .JS_Play(
            url, {
              //流媒体
              playURL: url,
              proxy: '10.1.254.20:559', //proxy后面的属性为代理的目标地址，根据实际情况配置，联网共享https下需要用到该参数
              mode: 'media' //建立连接的url新增一个media节点, 联网共享https下需要用到该参数
            },
            0
          )
          .then(
            () => {
              console.log('realplay success')
            },
            () => {
              console.log('realplay failed')
              this.$toast.fail('视频加载失败')
            }
          )

        // _this.fullSreen()
      },

      //获取容器宽高
      getWindHW(e) {
        try {
          /*  this.WindH = this.$refs.JSDecoderPlayerWind.offsetHeight
          this.WindW = this.$refs.JSDecoderPlayerWind.offsetWidth */
          //   this.WindH = e ? window.screen.width : parseInt((window.screen.width / 16) * 9)
          //   this.WindW = e ? parseInt((window.screen.width / 9) * 16) : window.screen.width

          window.onresize = () => {
            return (() => {
              var div = document.getElementById("JSDecoderPlayerWind");
              var w = div.offsetWidth;
              var h = div.offsetHeight;
              this.WindH = h - 1;
              this.WindW = w - 1;
              this.oPlugin.JS_Resize(this.WindW, this.WindH);
            })();
          };

        } catch (error) {
          console.log(error)
          console.log('JSDecoderPlayerWind dom未被挂载')
        }
      }
    }
  }

</script>
<style lang="scss">
  .JSDecoderPlayerWind {
    position: relative;
    width: 100%;
    height: 100%;
  }

</style>



// WEBPACK FOOTER //
// JSDecoderPlayer_ws.vue?37dbc514